import { Backbone } from "extensions/backbone";
import { request } from "common/components/request";

export const CredentialsModel = Backbone.Model.extend({
    idAttribute: "_id",
    urlRoot: "/credentials",
    defaults: () => ({
        display_name: "New credential",
        protocol: null,
        processor_name: null,
        merchant_ref: null,
        secure_fields: {}
    }),
    
    secureItemsFetched: false,
    
    getTitle() {
        return this.get("display_name");
    },
    
    /**
     * Get secured items data
     * @param [async = true] Set this to false to retrieve secured items data synchronously. This is necessary when calling document.execCommand("copy") later in the same stack
     * @returns {*}
     */
    getSecuredItems(async = true) {
        if (this.secureItemsFetched) {
            return Promise.resolve(this.get("secure_fields"));
        }
    
        return request(`${this.url()}/reveal`, { async }).then((data) => this.setSecureItems(data));
    },
    
    isResetRequested() {
        return this.get("reset_requested") === true;
    },
    
    setSecureItems(data) {
        this.set("secure_fields", data);
        this.secureItemsFetched = true;
        return data;
    },

    resetSecureItems() {
        this.set("secure_fields", {
            notes: "******",
            password: "******",
            username: "******"
        });
        this.secureItemsFetched = false;
    },
    
    resetCredentials() {
        return request(`${this.url()}/reset`, { method: "PATCH" }).then(() => this.set("reset_requested", true, { silent: true }));
    },
    
    updateModelWithChangedAttributes(changedAttributes) {
        // We switched to PUT from PATCH and will send back whole object to the API.
        // Therefore, we need to make sure secured items are fetched and not asterix
        return this.getSecuredItems().then(() => this.save(changedAttributes, { wait: true }));
    }
});
